import React from 'react';
import './InstallModal.css';

const InstallModal = ({ isOpen, onClose, onInstall, canInstall, onReload }) => {
  if (!isOpen) return null;

  return (
    <div className="install-modal-overlay" onClick={onClose}>
      <div className="install-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <span className="modal-icon">📱</span>
          <h2 className="modal-title">ऐप इंस्टॉल करें</h2>
          <p className="modal-subtitle">
            तेज़ एक्सेस और बेहतर अनुभव के लिए ऐप जोड़ें
          </p>
          <span className={`install-status ${canInstall ? 'ready' : 'waiting'}`}>
            {canInstall ? 'इंस्टॉल तैयार है' : 'इंस्टॉल उपलब्ध नहीं'}
          </span>
        </div>

        <div className="modal-content">
          {canInstall ? (
            <p className="modal-description">
              नीचे दिए गए बटन से इंस्टॉल शुरू करें। यदि ब्राउज़र अनुमति मांगे, तो "इंस्टॉल" दबाएं।
            </p>
          ) : (
            <p className="modal-description">
              इंस्टॉल पॉपअप अभी नहीं मिल रहा है। कृपया पेज रीफ्रेश करें या सामान्य (Incognito नहीं) Chrome/Edge में खोलें।
            </p>
          )}

          <div className="install-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-text">
                <strong>Chrome/Edge में:</strong> ब्राउज़र के ऊपरी दाएं कोने में <strong>⋮</strong> (तीन बिंदु) पर क्लिक करें
              </div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <div className="step-text">
                <strong>"ऐप इंस्टॉल करें"</strong> या <strong>"Install RR NEWS"</strong> विकल्प चुनें
              </div>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <div className="step-text">
                पॉपअप में <strong>"इंस्टॉल"</strong> बटन पर क्लिक करें
              </div>
            </div>
          </div>

          <div className="browser-note">
            <span className="note-icon">ℹ️</span>
            <p>
              <strong>नोट:</strong> यदि विकल्प दिखाई नहीं दे रहा है, तो कृपया <strong>Chrome</strong> या <strong>Edge</strong> ब्राउज़र का उपयोग करें।
              Firefox और Safari में PWA इंस्टॉलेशन सीमित है। Incognito मोड में इंस्टॉल नहीं होगा।
            </p>
          </div>

          <div className="modal-actions">
            <button
              className={`modal-btn primary ${canInstall ? '' : 'disabled'}`}
              onClick={canInstall ? onInstall : undefined}
              disabled={!canInstall}
              aria-disabled={!canInstall}
            >
              {canInstall ? 'इंस्टॉल करें' : 'इंस्टॉल तैयार नहीं'}
            </button>
            <button className="modal-btn ghost" onClick={onReload}>
              फिर से कोशिश करें
            </button>
            <button className="modal-btn ghost" onClick={onClose}>
              समझ गया
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallModal;
